<template>
  <v-container style="max-width: 1800px !important">
    <mostrar-detalles
      ref="mostrar_detalles"
    >
    </mostrar-detalles>
    <cambiar-estado
      ref="cambiar_estado"
      @change="getItems"
    >
    </cambiar-estado>
    <cuenta-bancarias
      ref="cuenta_bancarias"
    >
    </cuenta-bancarias>

    <editar-proveedor
      ref="editar_proveedor"
      @change="getItems"
    >
    </editar-proveedor>

    <div class="pa-3 ma-3">
      <v-row>
        <v-col cols="12" class="text-right">
          <v-btn color="primary" text @click="descargarProveedores">
            <v-icon> mdi-download </v-icon>
            Descargar Catálogo de Proveedores
          </v-btn>
        </v-col>
        <v-col cols="12">
          <v-card outlined class="pa-4">
            <div class="caption mb-1 pl-3">Estado de los Proveedores</div>
            <v-row class="pa-0 ma-0">
              <!-- Bloqueados -->
              <v-col cols="4" class="my-0 py-0">
                <div class="kpi-line">
                  <span class="kpi-figure">{{ pct(stats.bloqueado_per) }}</span>
                  <span class="kpi-pill kpi-pill--error">
                    {{ nf(stats.bloqueado_num) }} /
                    {{ nf(stats.total) }}
                  </span>
                </div>
                <v-progress-linear 
                  :value="stats.bloqueado_per * 100" 
                  height="8" 
                  color="red" 
                  class="mt-2"
                />
                <div class="caption mb-1">Bloqueados</div>
              </v-col>

              <!-- Pendientes de Validación -->
              <v-col cols="4" class="my-0 py-0">
                <div class="kpi-line">
                  <span class="kpi-figure">{{ pct(stats.pendiente_per) }}</span>
                  <span class="kpi-pill kpi-pill--warning">
                    {{ nf(stats.pendiente_num) }} /
                    {{ nf(stats.total) }}
                  </span>
                </div>
                <v-progress-linear 
                  :value="stats.pendiente_per * 100" 
                  height="8" 
                  color="orange" 
                  class="mt-2"
                />
                <div class="caption mb-1">Pendientes de Validación</div>
              </v-col>

              <!-- Validados -->
              <v-col cols="4" class="my-0 py-0">
                <div class="kpi-line">
                  <span class="kpi-figure">{{ pct(stats.validado_per) }}</span>
                  <span class="kpi-pill kpi-pill--success">
                    {{ nf(stats.validado_num) }} /
                    {{ nf(stats.total) }}
                  </span>
                </div>
                <v-progress-linear 
                  :value="stats.validado_per * 100" 
                  height="8" 
                  color="green" 
                  class="mt-2"
                />
                <div class="caption mb-1">Validados</div>
              </v-col>
            </v-row>
          </v-card>
        </v-col>
      </v-row>
      <v-row>
        
        <v-col cols="3">
          <v-text-field
            v-model="search.nombre"
            label="Nombre del Proveedor"
            dense
            outlined
            hide-details
            clearable
          >
          </v-text-field>
        </v-col>

        <v-col cols="3">
          <v-text-field
            v-model="search.email"
            label="Correo Electrónico"
            dense
            outlined
            hide-details
            clearable
          >
          </v-text-field>
        </v-col>
        <v-col cols="3">
          <v-text-field
            v-model="search.rfc"
            label="RFC"
            dense
            outlined
            hide-details
            clearable
          >
          </v-text-field>
        </v-col>
        <v-col cols="3">
          <v-text-field
            v-model="search.num_proveedor"
            label="# Proveedor"
            dense
            outlined
            hide-details
            clearable
          >
          </v-text-field>
        </v-col>

        <v-col cols="4">
          <v-autocomplete
            v-model="search.id_proveedor_tipo"
            item-value="id_proveedor_tipo"
            item-text="nombre"
            :items="proveedorTipos"
            label="Tipo de Proveedor"
            dense
            outlined
            hide-details
            clearable
          ></v-autocomplete>
        </v-col>

        <v-col cols="4">
          <v-autocomplete
            v-model="search.estado"
            item-value="id"
            item-text="nombre"
            :items="proveedorEstados"
            label="Estado"
            dense
            outlined
            hide-details
            clearable
          >
          </v-autocomplete>
        </v-col>

        <v-col cols="4">
          <v-btn block color="primary" text outlined @click="getItems">
            <v-icon>mdi-magnify</v-icon>
            Buscar
          </v-btn>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12">
          <v-data-table
            :loading="loading"
            :headers="headers"
            :items="items"
            :item-class="getRowClass"
          >
            <template v-slot:[`item.estado`]="{ item }">
              <!-- 🔴 BLOQUEADO -->
              <v-tooltip bottom v-if="item.bloqueado">
                <template v-slot:activator="{ on, attrs }">
                  <v-icon
                    v-bind="attrs"
                    v-on="on"
                    color="red"
                  >
                    mdi-lock-alert
                  </v-icon>
                </template>
                <span>
                  Bloqueado
                  <template v-if="item.motivo_bloqueo">
                    <br>
                    {{ item.motivo_bloqueo }}
                    <br>
                    {{ item.usuario_bloqueo }}
                    <br>
                    Desde {{ item.bloqueado_desde }}
                  </template>
                </span>
              </v-tooltip>

              <!-- 🟡 SIN VALIDAR -->
              <v-tooltip bottom v-else-if="!item.validado">
                <template v-slot:activator="{ on, attrs }">
                  <v-icon
                    v-bind="attrs"
                    v-on="on"
                    color="orange"
                  >
                    mdi-file-clock-outline
                  </v-icon>
                </template>
                <span>Pendiente de validación</span>
              </v-tooltip>

              <!-- 🟢 OK -->
              <v-tooltip bottom v-else>
                <template v-slot:activator="{ on, attrs }">
                  <v-icon
                    v-bind="attrs"
                    v-on="on"
                    color="green"
                  >
                    mdi-check-circle
                  </v-icon>
                </template>
                <span>Validado</span>
              </v-tooltip>
            </template>

            <template v-slot:[`item.actions`]="{ item }">
              <v-tooltip bottom color="black">
                <template v-slot:activator="{ on, attrs }">
                  <v-icon
                    class="mr-2"
                    small
                    @click="openDialogDetallesView(item)"
                    v-bind="attrs"
                    v-on="on"
                  >
                    mdi-eye
                  </v-icon>
                </template>
                <span>Ver Detalles</span>
              </v-tooltip>

              <v-tooltip bottom color="black">
                <template v-slot:activator="{ on, attrs }">
                  <v-icon
                    class="mr-2"
                    small
                    @click="openDialogEditar(item)"
                    v-bind="attrs"
                    v-on="on"
                  >
                    mdi-pencil
                  </v-icon>
                </template>
                <span>Editar</span>
              </v-tooltip>

              <v-tooltip
                v-if="!item.validado"
                bottom
                color="black"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-icon
                    class="mr-2"
                    small
                    v-bind="attrs"
                    v-on="on"
                    @click="cambiarEstado(item, !item.validado)"
                  >
                    mdi-progress-check
                  </v-icon>
                </template>
                <span>Validar Proveedor</span>
              </v-tooltip>

              <v-tooltip
                v-else
                bottom
                color="black"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-icon
                    class="mr-2"
                    small
                    v-bind="attrs"
                    v-on="on"
                    @click="cambiarEstado(item, !item.validado)"
                  >
                    mdi-progress-close
                  </v-icon>
                </template>
                <span>Desvalidar Proveedor</span>
              </v-tooltip>

              <v-tooltip bottom color="black">
                <template v-slot:activator="{ on, attrs }">
                  <v-icon
                    class="mr-2"
                    small
                    @click="openDialogCuentaBancariasView(item)"
                    v-bind="attrs"
                    v-on="on"
                  >
                    mdi-bank
                  </v-icon>
                </template>
                <span>Ver Cuentas Bancarias</span>
              </v-tooltip>

            </template>
          </v-data-table>
        </v-col>
      </v-row>
    </div>
  </v-container>
</template>

<script>
import axios from "axios";
import { mapState } from "vuex";
import MostrarDetalles from '../Proveedores/MostrarDetalles.vue';
import CambiarEstado from '../Proveedores/CambiarEstado.vue';
import CuentaBancarias from '../Proveedores/CuentaBancarias.vue'
import EditarProveedor from '../Proveedores/EditarProveedor.vue';

export default {
  components: {
    MostrarDetalles,
    CambiarEstado,
    CuentaBancarias,
    EditarProveedor
  },
  computed: {
    ...mapState(["token"]),
  },
  data: () => ({
    id_proveedor_nivel: '267c7302-72fc-4f96-988a-9ea1d2cf6fef',
    proveedorTipos: [],
    loadingProveedorTipos: false,

    personaTipos: [],
    loadingPersonaTipos: false,

    proveedoActividades: [],
    loadingProveedorActividad: false,

    regimenFiscales: [],
    loadingRegimenFiscales: false,

    estados: [],
    loadingEstados: false,

    municipios: [],
    loadingMunicipios: false,

    paises: [],
    loadingPaises: false,

    proveedorEstados: [
      { id: 1, nombre: 'Validado'},
      { id: 2, nombre: 'Pendiente de Validación'},
      { id: 3, nombre: 'Bloqueado'},
    ],

    search: {
      id_proveedor_tipo: null,
      nombre: null,
      email: null,
      rfc: null,
      num_proveedor: null,
      estado: null,
    },
    headers: [
      {
        text: "Estado",
        value: "estado",
        align: "center",
      },
      {
        text: "Clave del Proveedor",
        value: "clave",
        align: "center",
      },
      {
        text: "Nombre comercial",
        value: "nombre_completo",
        align: "center",
      },
      {
        text: "Tipo de Persona",
        value: "nombre_persona_tipo",
        align: "center",
      },
      /*
      {
        text: "Nivel de Proveedor",
        value: "nombre_proveedor_nivel",
        align: "center",
      },
      */
      {
        text: "Tipo de Proveedor",
        value: "nombre_proveedor_tipo",
        align: "center",
      },

      {
        text: "Nombre del Contacto",
        value: "nombre_contacto",
        align: "center",
      },

      {
        text: "Teléfono de Contacto",
        value: "telefono",
        align: "center",
      },

      {
        text: "Correo Electrónico",
        value: "correo_electronico",
        align: "center",
      },

      {
        text: "Acciones",
        value: "actions",
        sortable: false,
        align: "center",
      },
    ],
    items: [],
    loading: false,

    dialogAddEdit: false,
    editedItem: {
      id_proveedor: null,
      // Catálogos
      id_proveedor_tipo: null, // Guid
      id_persona_tipo: null, // Guid

      // UI / validación
      bloquear_rfc: false, // bool

      // Nacional
      rfc: null, // string
      id_proveedor_actividad: null, // Guid

      // Generales
      nombre_completo: null, // string
      nombre_contacto: null, // string
      correo_electronico: null, // string
      telefono: null, // string

      // Dirección
      calle: null,
      num_ext: null,
      num_int: null,

      // Fiscales nacionales
      razon_social: null,
      id_estado: null, // int
      id_municipio: null, // Guid
      id_regimen_fiscal: null, // Guid
      codigo_postal: null,
      localidad: null,
      colonia: null,

      // Fiscales internacionales
      numero_fiscal: null,
      ciudad: null,
      region: null,
      id_pais: null, // Guid
    },
    defaultEditedItem: {
      id_proveedor: null,
      // Catálogos
      id_proveedor_tipo: null, // Guid
      id_persona_tipo: null, // Guid

      // UI / validación
      bloquear_rfc: false, // bool

      // Nacional
      rfc: null, // string
      id_proveedor_actividad: null, // Guid

      // Generales
      nombre_completo: null, // string
      nombre_contacto: null, // string
      correo_electronico: null, // string
      telefono: null, // string

      // Dirección
      calle: null,
      num_ext: null,
      num_int: null,

      // Fiscales nacionales
      razon_social: null,
      id_estado: null, // int
      id_municipio: null, // Guid
      id_regimen_fiscal: null, // Guid
      codigo_postal: null,
      localidad: null,
      colonia: null,

      // Fiscales internacionales
      numero_fiscal: null,
      ciudad: null,
      region: null,
      id_pais: null, // Guid
    },
    saving: false,

    stats: {
      total: 0,
      bloqueado_num: 0,
      bloqueado_per: 0,
      pendiente_num: 0,
      pendiente_per: 0,
      validado_num: 0,
      validado_per: 0
    }
  }),
  mounted() {
    this.getProveedorNiveles();
    this.getProveedorTipos();
    this.getPersonaTipos();
    this.getProveedorActividades();
    this.getRegimenFiscales();
    this.getEstados();
    this.getPaises();
    this.getItems();
  },
  methods: {
    getProveedorNiveles() {
      this.loadingProveedorNivel = true;
      axios
        .get("/Proveedores/ListarProveedorNiveles")
        .then((response) => {
          this.proveedorNiveles = response.data;
        })
        .catch((error) => {
          console.log(error);
        })
        .finally(() => {
          this.loadingProveedorNivel = false;
        });
    },
    getProveedorTipos() {
      this.loadingProveedorTipos = true;
      axios
        .get("/Proveedores/ListarProveedorTipos")
        .then((response) => {
          this.proveedorTipos = response.data;
        })
        .catch((error) => {
          console.log(error);
        })
        .finally(() => {
          this.loadingProveedorTipos = false;
        });
    },
    getPersonaTipos() {
      this.loadingPersonaTipos = true;
      axios
        .get("/Proveedores/ListarPersonaTipos")
        .then((response) => {
          this.personaTipos = response.data;
        })
        .catch((error) => {
          console.log(error);
        })
        .finally(() => {
          this.loadingPersonaTipos = false;
        });
    },
    getProveedorActividades() {
      this.loadingProveedorActividad = true;
      axios
        .get("/Proveedores/ListarProveedorActividades")
        .then((response) => {
          this.proveedorActividades = response.data;
        })
        .catch((error) => {
          console.log(error);
        })
        .finally(() => {
          this.loadingProveedorActividad = false;
        });
    },
    getRegimenFiscales() {
      axios
        .get("/Catalogos/ListarRegimenFiscales")
        .then((response) => {
          this.regimenFiscales = response.data;
        })
        .catch((error) => {
          console.log(error);
        })
        .finally(() => {
          this.loadingRegimenFiscales = false;
        });
    },
    getEstados() {
      this.loadingEstados = true;
      axios
        .get("/Catalogos/ListarEstados")
        .then((response) => {
          this.estados = response.data;
        })
        .catch((error) => {
          console.log(error);
        })
        .finally(() => {
          this.loadingEstados = false;
        });
    },
    getMunicipios() {
      if (this.editedItem.id_estado == null || this.editedItem.id_estado == 0)
        return;
      this.loadingMunicipios = true;

      axios
        .get(`/Catalogos/ListarMunicipios/${this.editedItem.id_estado}`)
        .then((response) => {
          this.municipios = response.data;
        })
        .catch((error) => {
          console.log(error);
        })
        .finally(() => {
          this.loadingMunicipios = false;
        });
    },
    getPaises() {
      this.loadingPaises = true;

      axios
        .get("/Catalogos/ListarPaises")
        .then((response) => {
          this.paises = response.data;
        })
        .catch((error) => {
          console.log(error);
        })
        .finally(() => {
          this.loadingPaises = false;
        });
    },
    getItems() {
      const url = new URL(`http://localhost/Proveedores/ListarProveedores`);
      url.searchParams.append("id_proveedor_nivel", this.id_proveedor_nivel);

      if (this.search.id_proveedor_tipo != null) url.searchParams.append("id_proveedor_tipo",this.search.id_proveedor_tipo);
      if (this.search.nombre != null) url.searchParams.append("nombre", this.search.nombre);
      if (this.search.email != null) url.searchParams.append("email",this.search.email);
      if (this.search.rfc != null) url.searchParams.append("rfc",this.search.rfc);
      if (this.search.num_proveedor != null) url.searchParams.append("id_proveedor_tipo",this.search.num_proveedor);
      if (this.search.estado != null) url.searchParams.append("estado",this.search.estado);
      
      var url_string = url.href.replace("http://localhost", "");

      this.loading = true;
      axios
        .get(url_string)
        .then((response) => {
          this.items = response.data;
          this.calcularEstadisticas();
        })
        .catch((error) => {
          console.log(error);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    getRowClass(item) {
      if (item.bloqueado) return "danger-row-proveedores";
      if (!item.validado) return "pending-row-proveedores";
      return "";
    },
    nuevaPestana(url) {
      window.open(url, "_blank");
    },
    descargarProveedores() {
      this.nuevaPestana(
        `/api/Proveedores/DescargarProveedores?jwt=${this.token}&id_proveedor_nivel=${this.id_proveedor_nivel}`
      );
    },
    openDialogDetallesView(item){
      this.$refs.mostrar_detalles.open(item.id_proveedor);
    },
    openDialogCuentaBancariasView(item){
      this.$refs.cuenta_bancarias.open(item.id_proveedor);
    },
    cambiarEstado(item, estado){
      this.$refs.cambiar_estado.open(item, estado);
    },
    openDialogEditar(item){
      this.$refs.editar_proveedor.open(item);
    },
    calcularEstadisticas() {
      // Total de proveedores
      this.stats.total = this.items.length;
      
      if (this.stats.total === 0) {
        // Resetear todos los valores si no hay proveedores
        this.stats.bloqueado_num = 0;
        this.stats.bloqueado_per = 0;
        this.stats.pendiente_num = 0;
        this.stats.pendiente_per = 0;
        this.stats.validado_num = 0;
        this.stats.validado_per = 0;
        return;
      }
      
      // Contar proveedores por estado
      // 🔴 Bloqueados (tiene prioridad sobre los demás)
      this.stats.bloqueado_num = this.items.filter(
        prov => prov.bloqueado === true
      ).length;
      
      // 🟡 Pendientes de validación (no bloqueados Y no validados)
      this.stats.pendiente_num = this.items.filter(
        prov => !prov.bloqueado && !prov.validado
      ).length;
      
      // 🟢 Validados (no bloqueados Y validados)
      this.stats.validado_num = this.items.filter(
        prov => !prov.bloqueado && prov.validado === true
      ).length;
      
      // Calcular porcentajes
      this.stats.bloqueado_per = this.stats.bloqueado_num / this.stats.total;
      this.stats.pendiente_per = this.stats.pendiente_num / this.stats.total;
      this.stats.validado_per = this.stats.validado_num / this.stats.total;
    },
    
    // Función para formatear porcentaje
    pct(value) {
      return `${(value * 100).toFixed(1)}%`;
    },
    
    // Función para formatear números
    nf(value) {
      return value.toLocaleString('es-MX');
    }
  },
};
</script>


<style>
/*
.danger-row-proveedores {
  background-color: #fca5a5 !important;
  border-left: 5px solid #dc2626 !important;
  color: #7f1d1d !important;
  font-weight: 500 !important;
}
*/

.danger-row-proveedores {
  border-left: 5px solid #dc2626 !important;
}

.danger-row-proveedores td:not(:first-child):not(:last-child) {
  background: repeating-linear-gradient(
    45deg,
    #fecaca,
    #fecaca 10px,
    #fca5a5 10px,
    #fca5a5 20px
  ) !important;
  color: #7f1d1d !important;
  font-weight: 600 !important;
}

.danger-row-proveedores td:first-child,
.danger-row-proveedores td:last-child {
  background-color: white !important;
  color: inherit !important;
  font-weight: normal !important;
}

.danger-row-proveedores:hover td:not(:first-child):not(:last-child) {
  background: repeating-linear-gradient(
    45deg,
    #fca5a5,
    #fca5a5 10px,
    #f87171 10px,
    #f87171 20px
  ) !important;
}

.pending-row-proveedores {
  border-left: 5px solid #f59e0b !important;
}

.pending-row-proveedores td:not(:first-child):not(:last-child) {
  background: repeating-linear-gradient(
    45deg,
    #fffbeb,
    #fffbeb 10px,
    #fef3c7 10px,
    #fef3c7 20px
  ) !important;
  color: #92400e !important;
  font-weight: 500 !important;
}

.pending-row-proveedores td:first-child,
.pending-row-proveedores td:last-child {
  background-color: white !important;
  color: inherit !important;
  font-weight: normal !important;
}

.pending-row-proveedores:hover td:not(:first-child):not(:last-child) {
  background: repeating-linear-gradient(
    45deg,
    #fef3c7,
    #fef3c7 10px,
    #fde68a 10px,
    #fde68a 20px
  ) !important;
}

.kpi-line {
  display: flex;
  align-items: baseline;
  gap: 8px;
}

.kpi-figure {
  font-size: 1.6rem;
  font-weight: 700;
  line-height: 1;
}

.kpi-pill {
  display: inline-block;
  padding: 2px 8px;
  border-radius: 999px;
  font-weight: 600;
  font-size: 0.85rem;
  line-height: 1.2;
  border: 1px solid transparent;
}

/* Variantes de color (ajústalas a tu paleta Vuetify si quieres) */
.kpi-pill--success {
  background: #e8f5e9;   /* green lighten-5 */
  color: #2e7d32;        /* green darken-3 */
  border-color: #c8e6c9; /* green lighten-4 */
}

.kpi-pill--info {
  background: #e3f2fd;   /* blue lighten-5 */
  color: #1565c0;        /* blue darken-3 */
  border-color: #bbdefb; /* blue lighten-4 */
}

.kpi-pill--warning {
  background: #fff8e1;   /* amber lighten-5 */
  color: #ef6c00;        /* orange darken-3 */
  border-color: #ffe0b2; /* orange lighten-4 */
}
</style>